class SdAccountArea extends HTMLElement {
  connectedCallback() {
    this.links = [...this.querySelectorAll('[data-sd-account-link]')];
    this.panels = [...this.querySelectorAll('[data-sd-account-panel]')];
    this.toggle = this.querySelector('.sd-account-sidebar__toggle');
    this.toggle?.addEventListener('click', () => {
      const expanded = this.toggle.getAttribute('aria-expanded') === 'true';
      this.toggle.setAttribute('aria-expanded', String(!expanded));
    });
    this.links.forEach((link) => link.addEventListener('click', () => {
      this.show(link.dataset.sdAccountLink);
      this.toggle?.setAttribute('aria-expanded', 'false');
    }));
    window.addEventListener('hashchange', () => this.fromHash());
    this.fromHash();
  }
  fromHash() {
    const name = window.location.hash.slice(1);
    this.show(this.panels.some((panel) => panel.dataset.sdAccountPanel === name) ? name : 'panoramica');
  }
  show(name) {
    this.panels.forEach((panel) => { panel.hidden = panel.dataset.sdAccountPanel !== name; });
    this.links.forEach((link) => {
      const active = link.dataset.sdAccountLink === name;
      link.classList.toggle('is-active', active);
      active ? link.setAttribute('aria-current', 'page') : link.removeAttribute('aria-current');
    });
  }
}
if (!customElements.get('sd-account-area')) customElements.define('sd-account-area', SdAccountArea);
document.addEventListener('click', (event) => {
  document.querySelectorAll('.sd-account-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
